import { useFormikContext } from 'formik';
import Spacer from '@antimatterhq/ui/components/spacer';
import { Label } from '@antimatterhq/ui/components/label';
import { FormError, FormInput } from '@/components/form/form';
import { TransformSchemaValues } from '@/zod/schemas/transforms/TransformSchema';

export type TransformMetadataFormPropsType = {
  isInEditMode?: boolean;
};

export const TransformMetadataForm = ({
  isInEditMode,
}: TransformMetadataFormPropsType) => {
  const { values, handleChange, handleBlur } =
    useFormikContext<TransformSchemaValues>();

  return (
    <>
      <Label htmlFor="name" required id="name-label">
        Transform name
      </Label>
      <FormInput
        type="text"
        name="name"
        value={values.name}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder="Add a rule name"
        disabled={isInEditMode}
        aria-labelledby="name-label"
      />
      <FormError name="name" />

      <Spacer size="lg" />

      <Label htmlFor="comment" id="comment-label">
        Transform comment
      </Label>
      <FormInput
        type="text"
        name="comment"
        value={values.comment}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder="Add a comment for the rule"
        aria-labelledby="comment-label"
      />
      <FormError name="comment" />
    </>
  );
};
